export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    COURIER_DEVICE_COUNT_ALL: function COURIER_DEVICE_COUNT_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/courier-device-count/index',
        method: 'post',
        data: query
      });
    }
  };
});